import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const options = [
  { label: 'Default', value: 'default' },
  { label: 'Custom', value: 'custom' },
  { label: 'Host Model', value: 'host-model' },
  { label: 'Host Passthrough', value: 'host-passthrough' },
]

interface Props {}

export default function CpuModePicklist({
  name = 'cpuMode',
  label = 'CPU Mode',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
